{
  "title": "Deliver a deposit",
  "description": "Scan the deposit code with the tablet camera or enter the reference printed on the receipt.",
  "tabletRequired": "Choose a tablet",
  "find": {
    "title": "Find the deposit",
    "hint": "Enter the reference when the code cannot be read.",
    "scanning": "The camera is open on the tablet. Ask the customer to show the code."
  },
  "refusal": {
    "unknown": "Unknown reference number",
    "notInCustody": "This deposit is not in our custody ({{state}})",
    "closedBy": "Not in our custody. Status: {{state}}, by {{name}} on {{at}}",
    "otherBranch": "This deposit is held in {{branch}}",
    "forbidden": "You cannot deliver deposits in this branch"
  },
  "found": {
    "title": "Deposit details",
    "depositedAt": "Deposit date",
    "noIntended": "No recipient was recorded. Check the recipient's identity yourself."
  },
  "referralPending": "This deposit is awaiting supervisor review and cannot be delivered now.",
  "start": {
    "deliver": "Deliver"
  },
  "waiting": {
    "recipient": "The form is on the tablet. Waiting for the recipient.",
    "depositor": "The form is on the tablet. Waiting for the depositor.",
    "offline": "The tablet is offline. Make sure it is on, then resend.",
    "reconnecting": "The live connection dropped. Reconnecting..."
  },
  "compare": {
    "snapshot": "Depositor data at deposit"
  },
  "decide": {
    "deliveryHint": "Compare the recipient with the intended recipient, then decide.",
    "returnHint": "Compare the depositor with the data recorded at deposit, then decide.",
    "deliverStatement": "Hand the cash to {{name}}",
    "returnStatement": "Hand the cash back to the depositor {{name}}",
    "referStatement": "The deposit stays in our custody awaiting supervisor review. Write the reason."
  },
  "closed": {
    "DELIVERED": "The deposit was delivered successfully",
    "RETURNED": "The deposit was returned successfully",
    "REFERRED": "The deposit was referred to the supervisor",
    "number": "Deposit number {{number}}"
  },
  "nextDeposit": "Deliver another deposit"
}
